import {
  ITEMS,
  RECIPES,
  SHOP,
  PROJECTS,
  amount,
  recipeStatus,
  projectStatus,
  selectedItem,
} from "./crafting.js";
import { escapeHtml, withName } from "./util.js";
import { tileDataURL } from "./textures.js";
import { BLOCKS } from "./blocks.js";
const icons = new Map();
export function itemIcon(id) {
  const it = ITEMS[id];
  if (!it) return '<span class="item-empty">＋</span>';
  if (it.kind === "block") {
    if (!icons.has(id))
      icons.set(id, tileDataURL(BLOCKS[it.block].tex.side, 3));
    return `<img class="item-tile" src="${icons.get(id)}" alt="">`;
  }
  return `<span class="item-emoji" style="--item-colour:${it.colour}">${it.icon}</span>`;
}
export function hotbarHTML(d, act = "hotbar") {
  return `<div class="inventory-hotbar">${d.inventory.hotbar.map((id, i) => `<button class="hot-slot ${i === d.inventory.slot ? "selected" : ""} ${id && !amount(d, id) ? "empty-stack" : ""}" data-act="${act}" data-i="${i}" aria-label="Slot ${i + 1}: ${ITEMS[id]?.name || "empty"}${id ? ", " + amount(d, id) : ""}" aria-pressed="${i === d.inventory.slot}"><small>${i + 1}</small>${itemIcon(id)}<b>${id && ITEMS[id]?.kind !== "tool" ? amount(d, id) : ""}</b><span class="hot-name">${ITEMS[id]?.name || "Empty"}</span></button>`).join("")}</div>`;
}
const costHTML = (r) =>
  Object.entries(r.cost || {})
    .map(
      ([id, n]) =>
        `<span>${ITEMS[id].icon} ${n} ${ITEMS[id].name.toLowerCase()}</span>`,
    )
    .concat(
      r.coins ? [`<span>🪙 ${r.coins}</span>`] : [],
      r.gems ? [`<span>💎 ${r.gems}</span>`] : [],
    )
    .join("");
export function inventoryHTML(E, tab = "bag", group = "build") {
  const save = E.game.save.data,
    d = E.data,
    bench = E.nearBench();
  let body = "";
  if (tab === "bag") {
    const list = Object.keys(ITEMS).filter((id) => amount(d, id));
    body = `<div class="bag-instruction">${E.bagChoice ? `<b>${escapeHtml(ITEMS[E.bagChoice].name)}</b> selected. Tap a numbered slot below.` : "Tap an item, then a numbered slot to put it in your hand."}</div>${hotbarHTML(d, "bagSlot")}<div class="bag-grid">${list.map((id) => `<button class="bag-item ${E.bagChoice === id ? "chosen" : ""}" data-act="bagItem" data-id="${id}">${itemIcon(id)}<strong>${ITEMS[id].name}</strong><span>${ITEMS[id].kind === "tool" ? (ITEMS[id].tool === "equipment" ? "Useful equipment" : ITEMS[id].tool === "sword" ? `⚔️ Power ${ITEMS[id].power}` : `${ITEMS[id].speed}× gathering speed`) : amount(d, id)}</span></button>`).join("")}</div><button class="btn btn-purple" data-act="expansion" data-op="gear">✨ Equip armour & magic</button><p class="inventory-note">Your backpack keeps every item. The 8 slots are shortcuts. Food restores 2 hearts and gives you a 30-second speed boost. Tools never wear out.</p>`;
  } else if (tab === "craft" || tab === "shop") {
    const shop = tab === "shop";
    const basics=['planks','dirt','grass','cobble','dark_planks','log','stone_brick','brick','glass','leaves','sandstone','snow','ice','blue','pink','white','lime','slab','stairs','fence','ladder'];
    const recipes = shop ? SHOP : RECIPES.filter(r=>group==='tools' ? ITEMS[r.output].kind==='tool'&&ITEMS[r.output].tool!=='equipment' : group==='special' ? !basics.includes(r.output)&&(ITEMS[r.output].kind!=='tool'||ITEMS[r.output].tool==='equipment') : basics.includes(r.output));
    body = `<div class="bench-status ${bench ? "ready" : ""}">${bench ? "🛠️ Crafting table ready" : shop ? "Visit a crafting table to trade." : "Make simple blocks and a table anywhere. Other recipes need a table."}${!bench ? '<button class="btn btn-small btn-blue" data-act="findTable">Show me the town table →</button>' : ""}</div>${
      !shop
        ? `<div class="recipe-groups">${[
            ["build", "🧱 Building"],
            ["tools", "⛏️ Tools & swords"],
            ["special", "✨ Cool things"],
          ]
            .map(
              ([id, n]) =>
                `<button class="chip ${group === id ? "on" : ""}" data-act="recipeGroup" data-group="${id}">${n}</button>`,
            )
            .join("")}</div>`
        : ""
    }<div class="recipe-grid">${recipes
      .map((r) => {
        const status = recipeStatus(save, r, bench);
        if (shop && !bench) status.missing.unshift("Visit a crafting table");
        const it = ITEMS[r.output],
          owned = it.kind === "tool" && amount(d, r.output);
        return `<article class="recipe-card ${owned ? "owned" : ""}"><div class="recipe-title">${itemIcon(r.output)}<div><strong>${r.name || it.name}</strong><small>${it.kind === "tool" ? (it.tool === "equipment" ? "Keep forever · use in your world" : it.tool === "sword" ? `Power ${it.power} · works in Adventure too` : `${it.speed}× speed · tier ${it.rank + 1}`) : `Makes ${r.n} · you have ${amount(d, r.output)}`}</small></div></div><div class="recipe-cost">${costHTML(r)}</div>${r.blueprint && d.expansion?.adventures[r.blueprint] ? `<div class="learning-lock">📜 Blueprint discovered in Adventure ✓</div>` : r.learn ? `<div class="learning-lock">🧠 ${Math.min(save.stats.correct, r.learn)}/${r.learn} learned answers · any mode</div>` : ""}<p>${owned ? "✓ Yours forever" : escapeHtml(status.missing[0] || "Ready to make!")}</p><button class="btn btn-small ${status.ok && (!shop || bench) ? "btn-green" : "btn-dark"}" data-act="craftItem" data-id="${r.id}" data-shop="${shop ? 1 : 0}" ${!status.ok || (shop && !bench) ? "disabled" : ""}>${owned ? "Owned" : shop ? `Buy ${r.n}` : it.kind === "tool" ? "Craft tool" : `Craft ${r.n}`}</button></article>`;
      })
      .join(
        "",
      )}</div><p class="inventory-note">${shop ? "Coins earned in every mode buy useful supplies here. Gems help buy rare materials." : "Gather ingredients or buy them in Trade. Each finished 3-question lesson earns gems. Hints still count towards recipes."}</p>`;
  } else {
    body = `<p>Build something to be proud of. Each project rewards coins and gems once. There is no deadline.</p><div class="project-grid">${PROJECTS.map(
      (p) => {
        const st = projectStatus(save, p),
          done = d.projects[p.id];
        return `<article class="project-card"><h3>${done ? "✓ " : ""}${withName(p.name, escapeHtml(save.name))}</h3><p>${p.text}</p><div class="recipe-cost">${Object.entries(
          p.blocks,
        )
          .map(
            ([id, n]) =>
              `<span>${ITEMS[id].name}: ${Math.min(st.counts[id] || 0, n)}/${n}</span>`,
          )
          .join(
            "",
          )}</div><small>🧠 ${Math.min(save.stats.correct, p.learn)}/${p.learn} answers · 🪙 ${p.coins} + 💎 ${p.gems}</small><button class="btn btn-small ${st.ready ? "btn-green" : "btn-dark"}" data-act="claimProject" data-id="${p.id}" ${!st.ready ? "disabled" : ""}>${done ? "Completed" : st.ready ? "Collect reward" : "Keep building"}</button></article>`;
      },
    ).join("")}</div>`;
  }
  return `<div class="panel inventory-panel"><div class="inventory-head"><div><small>${escapeHtml(save.name.toUpperCase())}’S BACKPACK</small><h2>${{ bag: "Inventory", craft: "Craft something", shop: "Trade your treasure", projects: "Building projects" }[tab]}</h2></div><button class="btn btn-green btn-small" data-act="resume">Back to playing →</button></div><div class="inventory-wallet">🪙 ${save.coins} coins <span>💎 ${save.gems} gems</span><small>Earn in Adventure, Explore or Blitz · spend in any mode</small></div><nav class="inventory-tabs">${[
    ["bag", "🎒 Items"],
    ["craft", "🛠️ Craft"],
    ["shop", "🪙 Trade"],
    ["projects", "🏰 Projects"],
  ]
    .map(
      ([id, name]) =>
        `<button class="tab ${id === tab ? "on" : ""}" data-act="inventory" data-tab="${id}">${name}</button>`,
    )
    .join(
      "",
    )}</nav>${body}<div class="inventory-bottom"><button class="btn btn-small btn-dark" data-act="modeHome">⌂ Home screen · swap modes</button></div></div>`;
}
